module.exports = __webpack_public_path__ + "static/media/icon_list_table_current.d8155b84.svg";